import { useState } from 'react';

const useDialogState = (initialShowDialog = false): [boolean, () => void, () => void] => {
    const [showDialog, setShowDialog] = useState(initialShowDialog);
    const handleShowDialog = () => setShowDialog(true);
    const handleHideDialog = () => setShowDialog(false);

    return [showDialog, handleShowDialog, handleHideDialog];
}

export default useDialogState;